<template>
  <v-dialog v-model="show" persistent scrollable :max-width="600">
    <v-card>
      <dialog-header :title="title"
                     :close="close"/>
      <v-card-subtitle>

      </v-card-subtitle>
      <v-card-text>
        <p>{{ subtitle }}</p>
        <v-list>
          <planned-service-event-list-item v-for="item in items"
                                           :key="item.calendarEvent.id"
                                           :item="item"/>
        </v-list>
      </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click.stop="show = false">
          {{ $t('actions.cancel') }}
        </v-btn>
        <v-btn type="submit" tile color="primary" dark @click="confirm">
          {{ confirmButtonLabel }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Vue from 'vue';
import PlannedServiceEventListItem from '@/views/frontpage/planned-service-events-table/PlannedServiceEventListItem';
import DialogHeader from '@/components/layouts/DialogHeader';

export default Vue.extend({
  components: { DialogHeader, PlannedServiceEventListItem },
  name: 'PlannedServiceEventConfirmChangeDialog',

  props: {
    value: {
      type: Boolean,
      required: true,
    },
    items: {
      type: Array,
    },
    title: {
      type: String,
      required: true,
    },
    confirmButtonLabel: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
    },
  },

  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },

  methods: {
    confirm() {
      this.$emit('confirm', this.items);
    },
    close() {
      this.show = false;
    },
  },
});
</script>
